

import ViewBox from 'vux/src/components/view-box/index.vue'

import { mapState } from "vuex";

export default {
name: "app",
components: {
ViewBox,
},
created() {
localStorage.setItem("cacheCity", "");
},
mounted() {
let that = this;




},
computed: {
...mapState({
direction: (state) => state.vux.direction,
}),
viewTransition() {
if (!this.direction) return "";
return "vux-pop-" + (this.direction === "forward" ? "in" : "out");
},
},
};



// WEBPACK FOOTER //
// ./src/App.vue